// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Payout-btnRight-RgqBn {
  margin-right: 10px;
}

.Payout-btnFlex-WhXrS {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: end;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.Payout-payoutTitleFlex-i4TDP {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.Payout-paddingRight-MW6hi {
  padding: 24px 18px 0px;
}

.Payout-spaceBetWeen-YGTy8 {
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}

.Payout-alignItemBaseLine-V7u5q {
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
}

.Payout-itemPadding-NGn1i {
  padding: 0px 5px;
  line-height: 18px;
}

.Payout-radioBtn-eUR9C {
  top: 4px;
}

.Payout-fullWidth-WC1Ou {
  width: 100%;
}

.Payout-textAlignCenter-tUXOM {
  text-align: center !important;
}

.Payout-tolltipMargin-geo3Q {
  margin: 0px 3px 2px;
}

.Payout-payMinWidth-gMiGa {
  min-width: 56px;
}

@media screen and (max-width: 767px) {
  .Payout-btnFlex-WhXrS {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }


  .Payout-flexColumMobile-qfnvX {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
  }

  .Payout-btnRight-RgqBn {
    margin-right: 0px;
    margin-bottom: 10px;
  }

  .Payout-alignLeftMb-lvCKD {
    text-align: left;
  }
}

@media screen and (max-width: 480px) {
  .Payout-flexDirection-NOQGM {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: baseline;
        -ms-flex-align: baseline;
            align-items: baseline;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Payout/Payout.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAoB;MAApB,kBAAoB;UAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAGA;EACE,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;;EAGA;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,2BAAqB;QAArB,wBAAqB;YAArB,qBAAqB;EACvB;AACF","sourcesContent":[".btnRight {\n  margin-right: 10px;\n}\n\n.btnFlex {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n.payoutTitleFlex {\n  display: flex;\n  align-items: center;\n}\n\n.paddingRight {\n  padding: 24px 18px 0px;\n}\n\n\n.spaceBetWeen {\n  justify-content: space-between;\n}\n\n.alignItemBaseLine {\n  align-items: baseline;\n}\n\n.itemPadding {\n  padding: 0px 5px;\n  line-height: 18px;\n}\n\n.radioBtn {\n  top: 4px;\n}\n\n.fullWidth {\n  width: 100%;\n}\n\n.textAlignCenter {\n  text-align: center !important;\n}\n\n.tolltipMargin {\n  margin: 0px 3px 2px;\n}\n\n.payMinWidth {\n  min-width: 56px;\n}\n\n@media screen and (max-width: 767px) {\n  .btnFlex {\n    flex-direction: column;\n  }\n\n\n  .flexColumMobile {\n    flex-direction: column;\n  }\n\n  .btnRight {\n    margin-right: 0px;\n    margin-bottom: 10px;\n  }\n\n  .alignLeftMb {\n    text-align: left;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .flexDirection {\n    flex-direction: column;\n    align-items: baseline;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnRight": `Payout-btnRight-RgqBn`,
	"btnFlex": `Payout-btnFlex-WhXrS`,
	"payoutTitleFlex": `Payout-payoutTitleFlex-i4TDP`,
	"paddingRight": `Payout-paddingRight-MW6hi`,
	"spaceBetWeen": `Payout-spaceBetWeen-YGTy8`,
	"alignItemBaseLine": `Payout-alignItemBaseLine-V7u5q`,
	"itemPadding": `Payout-itemPadding-NGn1i`,
	"radioBtn": `Payout-radioBtn-eUR9C`,
	"fullWidth": `Payout-fullWidth-WC1Ou`,
	"textAlignCenter": `Payout-textAlignCenter-tUXOM`,
	"tolltipMargin": `Payout-tolltipMargin-geo3Q`,
	"payMinWidth": `Payout-payMinWidth-gMiGa`,
	"flexColumMobile": `Payout-flexColumMobile-qfnvX`,
	"alignLeftMb": `Payout-alignLeftMb-lvCKD`,
	"flexDirection": `Payout-flexDirection-NOQGM`
};
module.exports = ___CSS_LOADER_EXPORT___;
